import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from '../container/login/Index';

const Login = lazy(() => import('../container/login/SignIn'));

const FrontendRoutes = () => {
    return (
        <Suspense
            fallback={
                <div className="spin" style={{ display: 'grid', minHeight: '100vh', placeItems: 'center' }}>
                    <Spin size="large" />
                </div>
            }
        >
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </Suspense>
    );
};

export default AuthLayout(FrontendRoutes);
